<template>
  <input
    ref="customInput"
    class="text"
    :class="{ invalid: isInvalid }"
    type="text"
    :placeholder="placeholder"
    :value="localValue"
    @keyup.enter="confirmChange"
    @keyup.esc="cancelChange"
    @input="handleInput"
    @keydown="handleKeyDown"
  >
</template>

<script>
import debounce from '@/mixins/debounce';

export default {
  name: 'CustomInput',
  mixins: [debounce],
  props: {
    placeholder: {
      type: String,
      required: false,
    },
    modelValue: {
      type: String,
    },
    inputType: {
      type: String,
      default: 'text', // Possible values: 'text', 'digits', 'digitsAndPlus'
      required: false,
    },
    isInvalid: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      inputValue: '',
      localValue: this.modelValue || '',
    };
  },
  watch: {
    modelValue(newValue) {
      this.localValue = newValue || '';
    }
  },
  methods: {
    getInput() {
      return this.$refs.customInput.value;
    },
    clear() {
      this.$refs.customInput.value = '';
    },
    handleKeyDown(event) {
      // Allow navigation keys (arrows, backspace, delete, tab, etc.)
      if (event.key === 'ArrowLeft' || event.key === 'ArrowRight' || 
          event.key === 'Backspace' || event.key === 'Delete' || 
          event.key === 'Tab' || event.key === 'Enter' || 
          event.key === 'Escape' || event.ctrlKey || event.metaKey) {
        return;
      }

      if (this.inputType === 'digits') {
        // Allow only digits (0-9)
        if (!/^\d$/.test(event.key)) {
          event.preventDefault();
        }
      } else if (this.inputType === 'digitsAndPlus') {
        // Allow digits (0-9) and plus sign (+)
        if (!/^\d$/.test(event.key) && event.key !== '+') {
          event.preventDefault();
        }
        // Prevent multiple plus signs
        if (event.key === '+' && this.modelValue && this.modelValue.includes('+')) {
          event.preventDefault();
        }
      }
    },
    handleInput(event) {
      // Update local value and emit update event
      this.localValue = event.target.value;
      this.$emit('update:modelValue', this.localValue);
    },

    confirmChange() {
      // Emit update event when Enter is pressed
      this.$emit('update:modelValue', this.localValue);
      this.$emit('keyup:enter', this.localValue);
    },

    cancelChange() {
      // Revert to original value when Escape is pressed
      this.localValue = this.modelValue || '';
      this.$emit('keyup:esc');
    },
  },
};
</script>

<style scoped>
.holder-search input {
  width: 100%;
  height: auto;
}

.text {
  width: 100%;
  border-radius: 79px;
  border: 1px solid var(--input-placeholder-value-color);
  padding: 12px 15px !important;
  font-size: 12px;
}

.text:hover {
  filter: drop-shadow(0px 0px 5px rgba(200, 205, 212, 0.5));
}

.text::placeholder {
  color: var(--input-placeholder-value-color);
  font-size: 14px;
}

input {
  outline: none;
}

.text.invalid {
  border: 1px solid red;
}
</style>
